export enum ServiceType {
  TV = 'TV',
  INTERNET = 'INTERNET',
  VOIP = 'VOIP',
  XBOX_ALL_ACCESS = 'XBOX_ALL_ACCESS',
  FWA = 'FWA',
}
